import Bugsnag from "@bugsnag/js";

const apiKey = "0709918e5e0ec2d8bfad9d6575186e3a";

function shouldIgnoreError(error: any) {
  const message = String(
    error?.message ||
      error?.response?.data?.message ||
      error?.response?.statusText ||
      "",
  ).toLowerCase();

  const status = error?.response?.status;

  return (
    status === 429 ||
    message.includes("you are being rate limited") ||
    message.includes("resizeobserver loop completed with undelivered notifications")
  );
}

export const notifyBug = (error: any) => {
  if (shouldIgnoreError(error)) {
    return;
  }

  if (apiKey) {
    Bugsnag.notify(error);
  } else {
    console.error("Bugsnag notify skipped (not in production):", error);
  }
};
